const desktop = theme => {
  const {toVW} = theme;
  return {
    invisibleButton: {
      // width: '10%',
      // height: '10%',
      width: 80,
      height: 80,
    },
    emptySeatImg: {
      width: 80,
      height: 80,
    },
    seatPosition_0: {
      top: -35,
      left: 'unset',
    },
    seatPosition_1: {
      top: 0,
      left: 2.5,
    },
    seatPosition_2: {
      left: 25,
      top: 5,
    },
    seatPosition_3: {
      top: 2.5,
      left: 'unset',
    },
    seatPosition_4: {
      right: 25,
      top: 5,
    },
    seatPosition_5: {
      right: 2.5,
      top: 0,
    },
    seatPosition_0_allIn: {
      top: -30,
      left: 'unset',
    },
    seatPosition_1_allIn: {
      top: 2.5,
      left: 'unset',
    },
    seatPosition_3_allIn: {},
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    invisibleButton: {
      // ! original:
      // position: 'relative',
      // width: 50,
      // height: 50,
      // borderRadius: '50%',
      position: 'relative',
      width: 60,
      height: 60,
      borderRadius: '50%',
      border: 'none',
      background: 'transparent',
      '&:hover': {
        border: 'none',
        background: 'transparent',
      },
      '&.ant-btn[disabled]': {
        background: 'none',
      },
    },
    emptySeatImg: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: 60,
      height: 60,
    },
    imageSizeForPosition0: {
      width: 80,
      height: 80,
    },
    hidden: {
      filter: 'brightness(0.5)',
    },
    darken: {
      filter: 'brightness(0.5)',
    },
    seatPosition_0: {
      position: 'relative',
      // top: -40,
      top: 0,
      left: 0,
    },
    seatPosition_1: {
      position: 'relative',
      top: 0,
      left: 10,
    },
    seatPosition_2: {
      position: 'relative',
      left: 10,
    },
    seatPosition_3: {
      position: 'relative',
      top: -5,
      left: -10,
    },
    seatPosition_4: {
      position: 'relative',
      right: 10,
    },
    seatPosition_5: {
      position: 'relative',
      top: 0,
      right: 10,
    },
    seatPosition_0_allIn: {
      position: 'relative',
      top: -50,
    },
    seatPosition_1_allIn: {
      position: 'relative',
      left: -35,
      top: 'unset',
    },
    seatPosition_2_allIn: {
      position: 'relative',
      top: 0,
      left: 0,
    },
    seatPosition_3_allIn: {
      position: 'relative',
      right: 'unset',
    },
    loading: {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      zIndex: 2,
      height: '80%',
      width: '80%',
      background: 'black',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&.seatPosition_0': {
        width: '100%',
        height: '100%',
      },
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
